export const SCROLL_THRESHOLD_PX = 50;
export const OPTIONS_LIST_MAX_HEIGHT = 260;
